module.exports = __webpack_public_path__ + "static/media/hr-smart.92c111d5.svg";